export const NATURES = {
  Select: "Select",
  Performance: "Performance",
  Security: "Security",
  Unit_Level: "Unit Level",
  Functional: "Functional",
  Usability: "Usability",
  Syntax: "Syntax",
  Compatibility: "Compatibility",
  Logic: "Logic",
};
